import type { Components, Theme } from '@mui/material';

export const MuiFormLabel: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    root: () => ({
      fontSize: '14px',
      '&.MuiInputLabel-root': {
        transform: 'translate(14px, 9px) scale(1)',
      },
      '&.Mui-focused': {
        transform: 'translate(14px, -14px) scale(0.75)',
      },
      '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -14px) scale(0.75)',
      },
    }),
  },
};
